/**
 * groupDatabaseRelation模块接口列表
 */
import $http from "../utils/http"; // 导入http中创建的axios实例

const groupDatabaseRelation = {
  // 增加groupDatabaseRelation
  createRDSRelation(params) {
    return $http.post(
      `${global.API_URL}/sme/groupDatabaseRelation/create`,
      params
    );
  },
  //根据组ID查询数据库
  queryDatabaseByGroupId(params) {
    return $http.post(
      `${global.API_URL}/sme/groupDatabaseRelation/queryDatabaseByGroupId`,
      params
    );
  },
  //根据groupId和DatabaseId删除GroupDatabaseRelation模块
  deleteByGroupIdAndDatabaseId(params) {
    return $http.post(
      `${global.API_URL}/sme/groupDatabaseRelation/deleteByGroupIdAndDatabaseId`,
      params
    );
  },
  //查询当前用户可以查看的数据库
  queryDatabaseByGroup(params) {
    return $http.post(
      `${global.API_URL}/sme/groupDatabaseRelation/queryDatabaseByGroup`,
      params
    );
  },
  // 根据group查询Instance列表
  queryDatabaseByGroupMSP(params) {
    return $http.post(
      `${global.API_URL}/sme/groupDatabaseRelation/queryDatabaseByGroupMSP`,
      params
    );
  }
};

export default groupDatabaseRelation;



// WEBPACK FOOTER //
// ./src/api/groupDatabaseRelation.js